import { DefinitionType, ObjectDefinitions, type ItemDefinition } from "../../utils/objectDefinitions";

export interface ScopeDefinition extends ItemDefinition {
    readonly defType: DefinitionType.Scope

    readonly zoomLevel: number
    readonly giveByDefault?: boolean
}

/*
    Owner requests of 16 October 2026: the 6x (blue) takes the 8x's place (the sniper rifles come with it:
    ActiveRuleset.gunScopes, and the strong crates give one now and then: a fifth as often as the 4x, server
    lootTables.ts `special_scopes`), and the 1x is no longer handed out: everyone starts with the 2x only, and no
    loot gives a 1x (ActiveRuleset.removedItems). The 1x stays first in the list, as the closest view (DEFAULT_SCOPE),
    and the list stays in zoom order (the HUD, the inventory screen and scope switching go through it in order).
*/
export const Scopes = new ObjectDefinitions<ScopeDefinition>(([
    ["1x", 70],
    ["2x", 100, true],
    ["4x", 130],
    ["6x", 145],
    ["8x", 160],
    ["16x", 220]
    // Value 190 reserved for possible 12x scope
] satisfies readonly [string, number, boolean?][]).map(([magnification, zoomLevel, defaultScope]) => ({
    idString: `${magnification}_scope`,
    name: `${magnification} Scope`,
    defType: DefinitionType.Scope,
    noDrop: defaultScope,
    giveByDefault: defaultScope,
    zoomLevel
})));

/**
 * The closest view (the 1x's): what the camera shows inside a building, while downed and in smoke. Nobody carries
 * the 1x any more (owner request, 16 October 2026): players start with the 2x
 */
export const DEFAULT_SCOPE = Scopes.definitions[0];
